<template>
  <div class="addPro">
    <h1 style="font-size: 18px; margin-bottom: 40px;">展品速递</h1>
    <p style="font-size: 14px;">贵司上传的展品将在展会官网及小程序的“展品速递”中展出。</p>
    <p style="font-size: 14px;">参展企业须承诺所上传的展品不存在抄袭及侵权情况，如发生侵权纠纷，主办方将立即停止对于该产品的一切展示。并由参展企业承担相应的法律责任，主办方保留相关责任追溯权。</p>
    <p style="font-size: 14px;">展品描述性文字需真实准确，不存在蓄意夸大及虚假情况。</p>
    <p style="font-size: 14px;"><strong>企业须严格遵守以上原则，对于未能遵循的企业，主办方有权取消其参与资格并终止与其相关的推广活动。</strong></p>
    <p style="font-size: 14px; margin-top: 20px;"><strong>展品信息上传</strong></p>
    <p style="font-size: 14px;">完成以下中英文表格，您的展品信息将被显示在相应的中英文系统中，故请完整填写。</p>
    <el-row>
      <el-col :span="formSpan" :offset="formOff">
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="productForm" :label-position="labelP" size="small" :label-width="labelW">
          <el-form-item label="展品名称(中文)："  prop="pdtName">
            <el-input v-model="form.pdtName" show-word-limit maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="展品名称(英文)：" prop="pdtEName">
            <el-input v-model="form.pdtEName"  show-word-limit maxlength="60" ></el-input>
          </el-form-item>
          <el-form-item label="选择您的展品类型：" prop="typID">
            <el-select v-model="form.typID" placeholder="请选择：" @change="changeSelect">
              <el-option :label="val.typName" :value="val.typID" v-for="(val) in classTypeList" :key="val.typID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传展品图片：" prop="pdtLogos">
            <Upload :isFaceRead="false" :mediaUrl.sync="form.pdtLogos" :typeString = '"P"' />
            <el-input v-model="form.pdtLogos" style="display:none;"></el-input>
          </el-form-item>
          <el-form-item label="其他材料：" prop="pdtFileUrl">
            <Upload :isFaceRead="false" :mediaUrl.sync="form.pdtFileUrl" :typeString = '"P"' />
            <el-input v-model="form.pdtFileUrl" style="display:none;"></el-input>
          </el-form-item>
          <el-form-item label="新品介绍(中文)：	" prop="pdtIntro">
            <el-input type="textarea" maxlength="200" rows="4" show-word-limit v-model="form.pdtIntro"></el-input>
          </el-form-item>
          <el-form-item class="noRequire" label="新品介绍(英文)：" prop="pdtEIntro">
            <el-input type="textarea" maxlength="200" rows="4" show-word-limit v-model="form.pdtEIntro"></el-input>
          </el-form-item>
          <div class="mz">
            <p>*免责声明</p>
            <p>所有上传内容均由参展企业自主上传，与中国（上海）国际乐器展览会组委会立场无关。组委会不对其中包含或引用的信息的准确性、可靠性或完整性提供任何明示或暗示的保证。如因上传的文字内容触犯中华人民共和国相关法律条款，由参展上传企业应自行承担全部责任。
如任何单位或个人认为展品系统所展示的内容涉嫌侵犯其合法权益，应及时向中国（上海）国际乐器展览会组委会提出书面意见并提供相关证明材料和理由，收到上述文件后将采取相应措施。</p>
          </div>
          <el-form-item style="text-align: center; margin-top: 20px;">
            <el-checkbox v-model="ys2"><span style="color: red;">我同意</span></el-checkbox>
          </el-form-item>
          <el-form-item class="btns" v-if="isPC">
            <el-button size="medium" type="primary" @click="onSubmit">提交</el-button>
            <el-button size="medium" @click="back">返回</el-button>
          </el-form-item>
        </el-form>
        <div v-if="!isPC" style="text-align:center; padding: 18px 0;">
          <el-button size="medium" type="primary" @click="onSubmit">提交</el-button>
          <el-button size="medium" @click="back">返回</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@/api'
import Upload from '@/components/Upload'
import tools from '../../utils/tools.js';
import { validateEnCompany, validateChineseZipCode, validateEmail } from '@/utils/validator'
export default {
  data () {
    return {
      "id": `${this.$route.query.id}` === 'undefined' ? '' : `${this.$route.query.id}`,
      form: {
//      "pictureUrl": "",
        "pdtName": "",
        "pdtEName": "",
        "typID": "",
        "pdtIntro": "",
        "pdtEIntro": "",
//      "typName": "",
//      "pdtBrand": "",
        "pdtLogos": "",
        "pdtFileUrl": ""
        
      },
      classTypeList:[],
      rules: {
        pdtLogos: [{ required: true, message: '请上传展品图片', trigger: 'change' }],
        pdtFileUrl: [{ required: true, message: '请上传其他资料', trigger: 'change' }],
        pdtName: [{ required: true, message: '请填写新品中文名称', trigger: 'change' }],
        pdtEName: [{ required: true, message: '请填写新品英文名称', trigger: 'change' }],
        typID: [{ required: true, message: '请选择新品模块', trigger: 'change' }],
        pdtEIntro: [
          {
            validator: validateEnCompany,
            message: '只能输入英文字母和英文符号',
            trigger: 'blur',
            required: true
          }
        ],
        pdtIntro: [{ required: true, message: '新品中文介绍不能为空', trigger: 'change' }]
      },
      formSpan: 18,
      labelW: '200px',
      labelP: 'right',
      selSpn: 7,
      formOff: 2,
      isPC: true,
      ys2: false
    }
  },

  components: {
    Upload
  },
  mounted() {
    this.isPC = tools.isPC()
    if(!this.isPC) {
      this.formSpan= 24;
      this.formOff = 0
      this.labelW = '150px'
      this.labelP = 'left'
      this.selSpn = 22
    }
    this.getProductType()

    if(this.id !=''){
        api.productinfo({id : this.id}).then((res)=>{
            if(res.data.code =='200'){
              var _data = res.data.data
              this.form.pdtLogos = _data.pdtLogos[0]
              this.form.pdtFileUrl = _data.pdtFileUrl
              this.form.pdtName =  _data.pdtName
              this.form.pdtEName =  _data.pdtEName
              this.form.pdtIntro =  _data.pdtIntro
              this.form.pdtEIntro =  _data.pdtEIntro
//            this.form.typName =  _data.typName
              this.form.typID = _data.typID + ''
            }
        })
    }
  },

  methods: {
      //获取展品分类
      getProductType(){
        api.searchproducttype().then((res)=>{
            if(res.data.code =='200'){
              var _data = res.data.data
              this.classTypeList = _data
            }
        })
      },
    changeSelect(val){
       this.form.typID = val
    },
    onSubmit() {
      this.$refs['productForm'].validate((valid) => {
        if (valid) {
          var paramt = JSON.parse(JSON.stringify(this.form))
          if(this.id !=''){
            paramt.id = parseInt( this.id)
          }
          if(this.ys2 != true){
            this.$notify({
              title: '请勾选我同意',
              type: '提示',
              duration: 2000
            })
            return false
          }
          paramt.typID = parseInt(this.form.typID) 
          paramt.pdtLogos = [paramt.pdtLogos]
          api.saveproduct(paramt).then((res) => {
            if (res.data.code === 200) {
                this.$notify({
                  title: '保存成功',
                  type: 'success'
                })
                this.$router.go(-1)
            }
          })
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false
        }
      })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.blue {
  color: #409eff;
}

.title {
  margin-bottom: 30px;
}

.col-1-fix {
  padding-left: 0 !important;
}
.desc{
  font-size: 14px;
  line-height: 18px;
  padding: 10px;
}
.mz{
  font-size:14px;
  color:#999;
}
.btns{
  text-align: center;
  padding-top: 15px;
}
@media screen and (max-width:540px){
  .addPro{
    .el-form-item__label{
      font-size:14px;
    }
    .el-input--small .el-input__inner{
      border:0;
      text-align: right;
      padding-right: 45px;
    }
    .el-form-item{
      border-bottom: 1px solid #ededed;
    }
    .dash-upload{
      width:180px;
    }
    .noRequire .el-form-item__label::before{
      content: '';
      display: inline-block;
      width:10px;
    }
    .el-form-item__error{
      text-align: right;
      width:100%;
    }
  }
}
</style>
